module.exports = __webpack_public_path__ + "img/Olea_europaea.a032497e.jpg";